(function () {
  "use strict";

  if (window.dropdownFixInitialized) return;
  window.dropdownFixInitialized = true;

  let positioningTimeout = null;

  function getScrollParent(element) {
    let parent = element.parentElement;
    while (parent) {
      const style = window.getComputedStyle(parent);
      if (
        style.overflow === "auto" ||
        style.overflow === "scroll" ||
        style.overflowX === "auto" ||
        style.overflowX === "scroll" ||
        style.overflowY === "auto" ||
        style.overflowY === "scroll"
      ) {
        return parent;
      }
      parent = parent.parentElement;
    }
    return document.documentElement;
  }

  function positionDropdown(dropdown) {
    const button = dropdown.previousElementSibling;
    if (!button) return;

    const scrollParent = getScrollParent(dropdown);
    const isInScrollContainer = scrollParent !== document.documentElement;

    if (!isInScrollContainer) return;

    const dropdownParent = dropdown.parentElement;
    const originalPosition = window.getComputedStyle(dropdownParent).position;

    if (originalPosition === "static") {
      dropdownParent.style.position = "relative";
    }

    dropdown.style.position = "absolute";
    dropdown.style.zIndex = "9999";

    const dropdownWidth = dropdown.offsetWidth || 200;
    const spacing = 5;

    dropdown.style.right = `calc(100% + ${spacing}px)`;
    dropdown.style.left = "auto";
    dropdown.style.top = "0";
    dropdown.style.bottom = "auto";

    requestAnimationFrame(() => {
      const dropdownRect = dropdown.getBoundingClientRect();
      const scrollParentRect = scrollParent.getBoundingClientRect();
      const buttonRect = button.getBoundingClientRect();

      if (dropdownRect.left < scrollParentRect.left) {
        dropdown.style.right = "auto";
        dropdown.style.left = `calc(100% + ${spacing}px)`;
      }

      const newDropdownRect = dropdown.getBoundingClientRect();
      if (newDropdownRect.right > scrollParentRect.right) {
        dropdown.style.left = "0";
        dropdown.style.right = "auto";
        dropdown.style.top = `calc(100% + ${spacing}px)`;
      }
    });
  }

  function handleDropdownClick(e) {
    const button = e.target.closest(".button-dropdown .button");
    if (!button) return;

    const dropdown = button.parentElement;
    const menu = dropdown.querySelector(".dropdown-menu");
    if (!menu) return;

    setTimeout(() => {
      if (dropdown.classList.contains("open")) {
        positionDropdown(menu);
      }
    }, 0);
  }

  function updateOpenDropdowns() {
    document
      .querySelectorAll(".button-dropdown.open .dropdown-menu")
      .forEach((dropdown) => {
        positionDropdown(dropdown);
      });
  }

  function handleDropdownHover(e) {
    const target = e.target;
    if (target.classList && target.classList.contains("button-dropdown")) {
      const menu = target.querySelector(".dropdown-menu");
      if (menu) {
        requestAnimationFrame(() => {
          positionDropdown(menu);
        });
      }
    }
  }

  function initDropdownFix() {
    document.addEventListener("click", handleDropdownClick, true);

    document.addEventListener("mouseenter", handleDropdownHover, true);

    const scrollContainers = document.querySelectorAll(
      '.table-responsive, [data-scrollable="true"], #files-list'
    );
    scrollContainers.forEach((container) => {
      container.addEventListener("scroll", () => {
        if (positioningTimeout) {
          clearTimeout(positioningTimeout);
        }
        positioningTimeout = setTimeout(updateOpenDropdowns, 10);
      });
    });

    window.addEventListener("resize", updateOpenDropdowns);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class"
        ) {
          const target = mutation.target;
          if (
            target.classList.contains("button-dropdown") &&
            target.classList.contains("open")
          ) {
            const menu = target.querySelector(".dropdown-menu");
            if (menu) {
              setTimeout(() => positionDropdown(menu), 0);
            }
          }
        }
      });
    });

    document.querySelectorAll(".button-dropdown").forEach((dropdown) => {
      observer.observe(dropdown, {
        attributes: true,
        attributeFilter: ["class"],
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initDropdownFix);
  } else {
    initDropdownFix();
  }

  document.addEventListener("ajaxComplete", function () {
    setTimeout(initDropdownFix, 100);
  });
})();
